// LLEVARSE LOS DATOS — copiar al portapapeles y bajar un Excel.
//
// Las tres tablas de Estadísticas son `<Table>` de reactstrap armadas a mano,
// con su propio orden, su colapso y el resaltado del mejor y el peor día.
// `DataTableExtensions` —que sí se usa en Caja y en Mensuales— exige
// `react-data-table-component`, así que traerlo acá no era configurar: era
// reescribir las tres tablas y perder eso en el camino. Esto agrega la
// capacidad sin tocar una fila.
//
// Dos detalles que parecen menores y no lo son, porque el cliente abre esto en
// el Excel que tiene, no en el que nos gustaría:
//
//   · Separador `;` y no `,`. El Excel configurado en español espera punto y
//     coma; con coma, toda la fila cae en una sola columna.
//   · BOM al principio. Sin él, Excel abre el archivo en la codificación del
//     sistema y "Sábado 3 de agosto" llega como "SÃ¡bado".

import React, { useState } from "react";
import { Button } from "reactstrap";

const BOM = "\uFEFF";

const celda = (col, fila) => {
  const v = typeof col.valor === "function" ? col.valor(fila) : fila[col.key];
  return v === null || v === undefined ? "" : String(v);
};

/** Texto separado por TABS: pegado en Excel o Sheets cae en columnas solo. */
export const aTexto = (columnas, filas) =>
  [columnas.map((c) => c.label).join("\t")]
    .concat(filas.map((f) => columnas.map((c) => celda(c, f)).join("\t")))
    .join("\n");

export const aCSV = (columnas, filas) =>
  BOM + [columnas.map((c) => `"${c.label}"`).join(";")]
    .concat(filas.map((f) => columnas.map((c) => `"${celda(c, f).replace(/"/g, '""')}"`).join(";")))
    .join("\r\n");

const descargar = (contenido, nombre) => {
  const url = URL.createObjectURL(new Blob([contenido], { type: "text/csv;charset=utf-8;" }));
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Sin esto el blob queda en memoria hasta que se cierra la pestaña.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
};

/**
 * Dos botones chicos para llevarse una tabla.
 * @param {Array}  columnas  [{ key, label, valor? }] — `valor(fila)` para derivados
 * @param {Array}  filas     las filas tal como se muestran
 * @param {string} nombre    base del archivo, sin extensión
 */
export const BotonesExportar = ({ columnas, filas, nombre = "estadisticas" }) => {
  const [copiado, setCopiado] = useState(false);
  if (!filas?.length) return null;

  const copiar = async () => {
    const texto = aTexto(columnas, filas);
    try {
      await navigator.clipboard.writeText(texto);
    } catch {
      // navigator.clipboard no existe fuera de HTTPS ni en navegadores viejos.
      // Sin este camino, en esos casos el botón no haría nada y en silencio.
      const ta = document.createElement("textarea");
      ta.value = texto;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand("copy"); } catch { /* no hay más que intentar */ }
      document.body.removeChild(ta);
    }
    setCopiado(true);
    setTimeout(() => setCopiado(false), 2000);
  };

  const Icono = ({ nombre: n }) => (
    <span className="material-symbols-rounded me-1" style={{ fontSize: 14, verticalAlign: "middle" }}>{n}</span>
  );

  return (
    <div className="d-flex gap-2">
      <Button
        color={copiado ? "success" : "light"}
        size="sm"
        onClick={copiar}
        title="Copiar la tabla para pegarla en Excel, en un mail o en WhatsApp"
        style={{ fontSize: 12 }}
      >
        <Icono nombre={copiado ? "check" : "content_copy"} />
        {copiado ? "Copiado" : "Copiar"}
      </Button>
      <Button
        color="light"
        size="sm"
        onClick={() => descargar(aCSV(columnas, filas), `${nombre}.csv`)}
        title="Descargar la tabla para abrirla en Excel"
        style={{ fontSize: 12 }}
      >
        <Icono nombre="download" />
        Excel
      </Button>
    </div>
  );
};
